<script lang="ts">
	//Helpers
	import { isXT1ComponentDevice } from 'src/helpers/xt1_helpers/template_helpers';
	import {
		sendRequest,
		isDefaultTemplateType,
	} from 'src/helpers/xt1_helpers/template_request_helpers';
	//Components
	import IrrigationController from './Irrigation/IrrigationController.svelte';
	import ThermostatController from './Thermostat/ThermostatController.svelte';
	import ValveController from './Valve/ValveController.svelte';
	import Co2SensorStatuses from './CO2Sensor/CO2SensorStatuses.svelte';
	import NeoValveController from './NeoValve/NeoValveController.svelte';
	import EvChargerController from './EvCharger/EvChargerController.svelte';
	import TemplateController from './Components/TemplateController.svelte';
	import DehumidifierController from './Dehumidifier/DehumidifierController.svelte';
	import WindowCoverController from './WindowCover/WindowCoverController.svelte';
	import SwitchController from './Switch/SwitchController.svelte';
	import LightController from './Light/LightController.svelte';
	import XT1ComponentDevice from './GenComponent/XT1ComponentDevice.svelte';
	import { DeviceDrawer } from '@shelly/device-templates';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	$: templateType = statuses?.[0]?.templateType;
	$: defaultTemplateType = isDefaultTemplateType(statuses?.[0]?.serviceType);
</script>

{#if defaultTemplateType}
	<DeviceDrawer {device} {statuses} templateType={statuses[0]?.serviceType} {sendRequest} />
{:else if templateType === 'irrigation'}
	<IrrigationController {device} {statuses} />
{:else if templateType === 'light'}
	<LightController {device} {statuses} />
{:else if templateType === 'switch'}
	<SwitchController {device} {statuses} />
{:else if templateType === 'thermostat'}
	<ThermostatController {device} {statuses} />
{:else if templateType === 'valve'}
	<ValveController {device} {statuses} />
{:else if templateType === 'cover'}
	<WindowCoverController {device} {statuses} />
{:else if templateType === 'co2-sensor'}
	<Co2SensorStatuses {device} {statuses} />
{:else if templateType === 'neo-valve'}
	<NeoValveController {device} {statuses} />
{:else if templateType === 'ev-charger'}
	<EvChargerController {device} {statuses} on:click />
{:else if templateType === 'dehumidifier'}
	<DehumidifierController {device} {statuses} on:click />
{:else if isXT1ComponentDevice(device)}
	<XT1ComponentDevice {device} />
{:else}
	<TemplateController {device} {statuses} />
{/if}
